import Vue from 'vue';

export default {
  state: {
    tranches: [],
  },
  getters: {
    tranches(state) {
      return state.tranches;
    },
    // eslint-disable-next-line
    tranche: state => (id) => {
      return state.tranches.find(type => type.id === id) || {};
    },
  },
  mutations: {
    SET_TRANCHES(state, payload) {
      state.tranches = payload;
    },
  },
  actions: {
    GET_TRANCHES(context) {
      return Vue.axios.get('filters/tranches').then((response) => {
        context.commit('SET_TRANCHES', response.data);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/tranches.js